<div class="ui-image-mosaic">
  <div class="ui-image-mosaic__grid">
    @for (group of tiles(); track group.id; let index = $index) {
      <button
        type="button"
        class="ui-image-mosaic__tile"
        [class.ui-image-mosaic__tile--hero]="index === 0"
        [attr.aria-label]="'Abrir galería de ' + group.label"
        (click)="openGroup(group.id)"
      >
        <img
          class="ui-image-mosaic__image"
          [src]="group.cover"
          [alt]="tileAlt(group)"
        />
      </button>
    }
  </div>
</div>

<ui-drawer
  [open]="drawerOpen()"
  (openChange)="onDrawerOpenChange($event)"
  placement="center"
  [title]="title()"
  [mobileTitle]="project() || title()"
  [showSaveButton]="false"
  [fill]="true"
  [tabletAsMobile]="true"
  panelWidth="90vw"
  panelHeight="90dvh"
>
  @if (unit()) {
    <p class="ui-image-mosaic__unit">{{ unit() }}</p>
  }
  <div class="ui-image-mosaic__viewer">
    <div class="ui-image-mosaic__groups" role="list">
      @for (group of groups(); track group.id) {
        <button
          type="button"
          class="ui-image-mosaic__group"
          [class.ui-image-mosaic__group--active]="selectedGroup().id === group.id"
          [attr.aria-current]="selectedGroup().id === group.id ? 'true' : null"
          (click)="selectGroup(group.id)"
        >
          <span class="ui-image-mosaic__group-thumb">
            <img
              class="ui-image-mosaic__group-image"
              [src]="group.cover"
              [alt]="tileAlt(group)"
            />
          </span>
          <span class="ui-image-mosaic__group-label">{{ group.label }}</span>
        </button>
      }
    </div>

    <div
      class="ui-image-mosaic__stage"
      (pointerdown)="onStageSwipeStart($event)"
      (pointerup)="onStageSwipeEnd($event)"
      (pointercancel)="onStageSwipeCancel()"
    >
      <div
        class="ui-image-mosaic__reel"
        [class.ui-image-mosaic__reel--pair]="incomingIndex() !== null"
        [class.ui-image-mosaic__reel--next]="
          incomingIndex() !== null && direction() === 'next'
        "
        [class.ui-image-mosaic__reel--prev]="
          incomingIndex() !== null && direction() === 'prev'
        "
        [class.ui-image-mosaic__reel--run]="pushing()"
        (transitionend)="onPushEnd($event)"
      >
        @for (frame of frames(); track frame.index) {
          <div class="ui-image-mosaic__frame">
            <img
              class="ui-image-mosaic__stage-image"
              [src]="frame.src"
              [alt]="selectedGroup().label"
            />
          </div>
        }
      </div>
      @if (frames().length) {
        <button
          type="button"
          class="ui-image-mosaic__stage-open"
          [attr.aria-label]="'Ver ' + selectedGroup().label + ' a pantalla completa'"
          (click)="openLightbox()"
        ></button>
      }
      @if (canCycle()) {
        <button
          type="button"
          class="ui-image-mosaic__nav ui-image-mosaic__nav--prev"
          aria-label="Imagen anterior"
          (click)="showPrevious()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M14.5 6.5 9 12l5.5 5.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <button
          type="button"
          class="ui-image-mosaic__nav ui-image-mosaic__nav--next"
          aria-label="Imagen siguiente"
          (click)="showNext()"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M9.5 6.5 15 12l-5.5 5.5"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      }
    </div>
  </div>
</ui-drawer>

<ui-image-lightbox
  [open]="lightboxOpen()"
  (openChange)="lightboxOpen.set($event)"
  [images]="selectedGroup().images"
  [index]="imageIndex()"
  (indexChange)="imageIndex.set($event)"
  [alt]="selectedGroup().label"
  [caption]="project() || title()"
/>
